import { render, staticRenderFns } from "./newPart.vue?vue&type=template&id=5b9ef20c&"
import script from "./newPart.vue?vue&type=script&lang=js&"
export * from "./newPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports